import React from 'react';

const FacebookLikesWidget = ({ likes }) => (
  <div>
    <div className="mb-2">Facebook Likes</div>
    <strong>{likes} likes</strong>
  </div>
);

export default FacebookLikesWidget;


